// import { Box, Button, CloseButton, Flex, HStack, Stack, Text } from "@chakra-ui/react";
// import { useState } from "react";

// // 1. Sidebar Component (Box implementation)
// export const SpellingSidebar = ({ isOpen, onClose, totalUS, totalUK, allKeys, stats, handleConvert, editorRef, handleMajor }) => {

//     const [expandedKeys, setExpandedKeys] = useState({});
//     if (!isOpen) return null;

//     // Toggle state to track which word is expanded


//     const toggleExpand = (key) => {
//         const isExpanding = !expandedKeys[key];
//         setExpandedKeys(prev => ({ ...prev, [key]: isExpanding }));

//         // Highlight logic
//         if (isExpanding && editorRef?.current) {
//             const wordToFind = key.split('/')[0];
//             editorRef.current.find(wordToFind, { backwards: false, wrap: true, caseSensitive: false });
//         }
//     };



//     return (
//         <Box
//             position="fixed"
//             right="0"
//             top="0"
//             h="100vh"
//             w="sm"
//             bg="white"
//             zIndex="1000"
//             borderLeft="1px solid #e2e8f0"
//             boxShadow="lg"
//             overflowY="auto"
//             pointerEvents="auto"
//         >
//             {/* Header */}
//             <Flex p={4} borderBottom="1px solid #e2e8f0" justify="space-between" align="center">
//                 <Text fontWeight="bold" fontSize="lg">Spelling Check</Text>
//                 {/* Total Stats */}
//                 <HStack justify="space-between" >
//                     <Text fontWeight="medium">US: {totalUS} | UK: {totalUK}</Text>
//                 </HStack>
//                 <CloseButton onClick={onClose} />
//             </Flex>

//             <Box py={6} px={2}>


//                 <Stack spacing={4}>
//                     {allKeys.map((key) => {
//                         const item = stats[key];
//                         const isExpanded = expandedKeys[key];
//                         return (
//                             <Box key={key} overflow="hidden">
//                                 <Flex justify="space-between" align="center" px={8} mb={2}>
//                                     <Text>US Word : {item.us}</Text>
//                                     <Text>Uk Word : {item.uk}</Text>
//                                 </Flex>
//                                 <Flex align="center">
//                                     <Button size="xs" mr={2} onClick={() => toggleExpand(key)}>
//                                         {isExpanded ? "-" : "+"}
//                                     </Button>
//                                     <Flex flex={1}>
//                                         <Box bg="red.500" color="white" px={3} py={1} flex={1}>{item.us}: {item.usCount}</Box>
//                                         <Box bg="blue.900" color="white" px={3} py={1} flex={1}>{item.uk}: {item.ukCount}</Box>
//                                     </Flex>
//                                 </Flex>

//                                 {isExpanded && (
//                                     <Box p={3} borderTop="1px solid #eee">
//                                         {/* First Row: US and UK side-by-side */}
//                                         <Flex justify="space-between" mb={2}>
//                                             <Text
//                                                 as="span"
//                                                 cursor="pointer"
//                                                 fontSize="sm"
//                                                 fontWeight="medium"
//                                                 color="black"
//                                                 onClick={() => handleConvert("US", key)}
//                                             >
//                                                 Convert to US
//                                             </Text>
//                                             <Text
//                                                 as="span"
//                                                 cursor="pointer"
//                                                 fontSize="sm"
//                                                 fontWeight="medium"
//                                                 color="black"
//                                                 onClick={() => handleConvert("UK", key)}
//                                             >
//                                                 Convert to UK
//                                             </Text>
//                                         </Flex>

//                                         {/* Second Row: Major Occurrence */}
//                                         <Text
//                                             cursor="pointer"
//                                             fontSize="sm"
//                                             fontWeight="medium"
//                                             color="black"
//                                             onClick={() => handleMajor(key)}
//                                         // Ensure this function is defined in your scope
//                                         >
//                                             Convert to Major Occurrence
//                                         </Text>
//                                     </Box>
//                                 )}
//                             </Box>
//                         );
//                     })}
//                 </Stack>
//             </Box>
//         </Box>
//     );
// };

import { Box, Button, CloseButton, Flex, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";

export const SpellingSidebar = ({ isOpen, onClose, totalUS, totalUK, allKeys, stats, handleConvert, editorRef, handleMajor }) => {
    const [selectedKey, setSelectedKey] = useState(null);
    if (!isOpen) return null;

    const selectItem = (key) => {
        setSelectedKey(key);
        if (editorRef?.current) {
            const wordToFind = key.split('/')[0];
            editorRef.current.find(wordToFind, { backwards: false, wrap: true, caseSensitive: false });
        }
    };

    const activeItem = selectedKey ? stats[selectedKey] : null;

    return (
        <Box position="fixed" right="0" top="0" h="100vh" w="sm" bg="white" zIndex="1000" borderLeft="1px solid #e2e8f0" boxShadow="lg" display="flex" flexDirection="column">
            {/* Header */}
            <Flex p={4} borderBottom="1px solid #e2e8f0" justify="space-between" align="center">
                <Text fontWeight="bold" fontSize="lg">Spelling Check</Text>
                <Text fontWeight="medium">US: {totalUS} | UK: {totalUK}</Text>
                <CloseButton onClick={onClose} />
            </Flex>

            {/* Dynamic Word Display */}
            <Flex justify="space-between" px={8} py={4} fontWeight="bold" borderBottom="1px solid #eee" bg="gray.50">
                <Text>US: {activeItem ? activeItem.us : "---"}</Text>
                <Text>UK: {activeItem ? activeItem.uk : "---"}</Text>
            </Flex>

            {/* Scrollable List */}
            <Box flex="1" overflowY="auto" py={2}>
                <Stack spacing={0}>
                    {allKeys.map((key) => {
                        const item = stats[key];
                        const isSelected = selectedKey === key;
                        return (
                            <Box key={key} borderBottom="1px solid #eee" bg={isSelected ? "blue.50" : "transparent"}>
                                <Flex align="center" p={3} cursor="pointer" onClick={() => selectItem(key)}>
                                    <Flex flex={1}>
                                        <Box bg="red.500" color="white" px={3} py={1} flex={1}>{item.us}: {item.usCount}</Box>
                                        <Box bg="blue.900" color="white" px={3} py={1} flex={1}>{item.uk}: {item.ukCount}</Box>
                                    </Flex>
                                </Flex>
                            </Box>
                        );
                    })}
                </Stack>
            </Box>

            {/* Common Fixed Footer Buttons */}
            <Box p={4} borderTop="2px solid #e2e8f0" bg="white">
                <VStack spacing={2}>
                    <Button w="full" size="sm" variant="outline" colorScheme="blue"
                        isDisabled={!selectedKey} onClick={() => handleConvert("US", selectedKey)}>
                        Convert to US
                    </Button>
                    <Button w="full" size="sm" variant="outline" colorScheme="blue"
                        isDisabled={!selectedKey} onClick={() => handleConvert("UK", selectedKey)}>
                        Convert to UK
                    </Button>
                    <Button w="full" size="sm" colorScheme="green"
                        isDisabled={!selectedKey} onClick={() => handleMajor(selectedKey)}>
                        Convert to Major Occurrence
                    </Button>
                </VStack>
            </Box>
        </Box>
    );
};